export const SET_SECTION = 'SET_SECTION';
export const SET_DIVISION = 'SET_DIVISION';
export const SET_DOCUMENTS = 'SET_DOCUMENTS';
export const SET_DOCUMENTS_TYPE = 'SET_DOCUMENTS_TYPE';
export const SET_SUBMITTAL_SECTIONS = 'SET_SUBMITTAL_SECTIONS';
